import { ColumnDetails, ColumnType } from '../../../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { getExchangeAntimalwareScanTaskExclusionTypeGridValues } from '../../../../../../../utils/uiSettings/exchange/exchange-protection.values';

export enum Column {
  TYPE = 1,
  SCOPE,
}

export enum ColumnKeys {
  TYPE = 'type',
  SCOPE = 'scope',
}

export const GRID_COLUMNS = [Column.TYPE, Column.SCOPE];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.TYPE,
      key: ColumnKeys.TYPE,
      columnName: translateFn('Type'),
      type: ColumnType.ENUM,
      values: getExchangeAntimalwareScanTaskExclusionTypeGridValues(),
      removable: false,
      filteringDisabled: true,
      sortable: true,
      editingDisabled: true,
    },
    {
      column: Column.SCOPE,
      key: ColumnKeys.SCOPE,
      columnName: translateFn('Scope'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
  ];
}
